var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComentFbDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 3H5.25C4.00898 3 3 4.00898 3 5.25V15.375C3 16.616 4.00898 17.625 5.25 17.625H8.625V20.5781C8.625 20.8277 8.82891 21 9.04688 21C9.13125 21 9.21914 20.9754 9.29648 20.9156L13.6875 17.625H18.75C19.991 17.625 21 16.616 21 15.375V5.25C21 4.00898 19.991 3 18.75 3ZM19.3125 15.375C19.3125 15.6844 19.0594 15.9375 18.75 15.9375H13.125L12.675 16.275L10.3125 18.0469V15.9375H5.25C4.94062 15.9375 4.6875 15.6844 4.6875 15.375V5.25C4.6875 4.94062 4.94062 4.6875 5.25 4.6875H18.75C19.0594 4.6875 19.3125 4.94062 19.3125 5.25V15.375Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComentFbDesign);
export default __webpack_public_path__ + "static/media/coment_fb_design.2afbd2842a7fb9ef9f8660980a2f0daa.svg";
export { ForwardRef as ReactComponent };